export default "__VITE_ASSET__BM$qjncN__"